import axiosInstance from '../../core/axiosConfig';

export default class CategoryService {
  async createCategory(payload: any) {
    const response = await axiosInstance.post('/category/create', payload);
    return response.data;
  }
  async deleteCategory(categoryId: number) {
    await axiosInstance.delete('/category/delete', { params: { categoryId } });
  }
}
